let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6UruI")).then(() => parcelRequire('cCggp'));